const toBase64 = async (
  file?: File | string,
): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    if (!file) {
      resolve(null);

      return;
    }

    if (typeof file === "string") {
      resolve(file);

      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (): void => resolve(reader.result);
    reader.onerror = reject;
  });

export default toBase64;
